export const dynamicWorkflowHook = () => {
  const container = document.createElement('div')
  const component = `<component v-for="n in dynamicWQ"
                                :is="n.type"
                                :id="n.id"
                                :wid="n.wid"
                                :sid="n.sid"
                                :readonly="n.readonly"
                                :params="n.params"></component>`
  document.body.appendChild(container)
  container.innerHTML = component
}



// WEBPACK FOOTER //
// ./src/helpers.js